"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.holdCase = void 0;
exports.holdCase = {
    hold_reason: "Hold",
    comment: "hold",
    coding_manager_id: ""
};
//# sourceMappingURL=hold-case.js.map